class AddTouristAvatarClassificationParameters {
  /** 分类备注 */
  memo = '';

  /** 分类名称 */
  name = '';
}

class CodeEditorStatus {
  /** 开启代码编辑器的参会设备ID */
  codeEditorEnableDeviceId = '';

  /** 开启代码编辑器的参会人uid */
  codeEditorEnableUid = '';

  /** 代码编辑器是否开启 */
  codeEditorEnabled = false;

  /** 代码编辑器地址 */
  codeEditorUrl = '';
}

class ConferenceInteractiveWhiteboardStatusInformation {
  /** 互动白板开启的参会设备ID */
  wbEnableDeviceId = '';

  /** 互动白板开启权限 1-所有人可开启 2-仅主持人可开启 */
  wbEnablePermission = undefined;

  /** 开启互动白板的参会人uid */
  wbEnableUid = '';

  /** 互动白板是否已开启 */
  wbEnabled = false;

  /** InteractiveWhiteBanCloudCertificationParameters */
  wbYxAuthArgs = new InteractiveWhiteBanCloudCertificationParameters();
}

class ConferenceNotifyTheAuthenticationInformationConnection {
  /** STOMP 服务订阅地址，包含多个用于下发通知的 destination，都需要订阅 */
  stompDestinations = [];

  /** STOMP 服务连接地址，会拼接认证参数 */
  stompEndpoint = '';
}

class ConferenceReactionConfiguration {
  /** 是否已启用表情 Reaction */
  emoticonReactionEnabled = false;
}

class ConferenceRecordingRelatedStatus {
  /** 是否允许参会人分享会议录制文件，如不传递则默认禁止 */
  isShareableForMember = false;

  /** 是否开启录制文件水印，如不传递则默认开启水印 */
  isWatermarkEnabled = false;

  /** ConferenceRecordingStatus，1-录制中，2-已暂停，3-已停止；默认状态 3-已停止。 */
  status = undefined;
}

class ConferenceRecordingStatus {
  /** 是否允许参会人共享录制文件 */
  isShareableForMember = false;

  /** 是否开启水印 */
  isWatermarkEnabled = false;

  /** ConferenceRecordingStatus */
  status = undefined;
}

class ConferenceShareScreenStatusInformation {
  /** 批注是否可以保存快照 */
  canSaveAnnotateSnapshot = false;

  /** 共享屏幕批注是否已开启 */
  shareAnnotateEnabled = false;

  /** 共享屏幕批注权限 参考枚举 ShareAnnotatePermission */
  shareAnnotatePermission = undefined;

  /** 共享批注白板云信认证参数 */
  shareAnnotateWbYxAuthArgs =
    new InteractiveWhiteBanCloudCertificationParameters();

  /** 屏幕共享是否已开启 */
  shareEnabled = false;

  /** 正在进行屏幕共享的参会人设备ID */
  shareMemberDeviceId = '';

  /** 屏幕共享中的参会人uid */
  shareMemberUid = '';

  /** 共享屏幕权限 参考枚举 SharePermission */
  sharePermission = undefined;

  /** 共享屏幕抢断权限 参考枚举 ShareSnatchPermission */
  shareSnatchPermission = undefined;

  /** 共享源窗口高度，物理像素 */
  shareSourceHeight = undefined;

  /** 共享源窗口宽度，物理像素 */
  shareSourceWidth = undefined;
}

class ConferenceTranslatorConfiguration {
  /** 译员参会设备ID，如译员未入会此字段为 null */
  deviceId = '';

  /** 译员互译源语言名称 */
  fromLanguageName = '';

  /** 译员互译源语言名称，简写形式，用于标签展示，如：中、英、zh、en */
  fromLanguageNameShort = '';

  /** 译员互译源语言 tag */
  fromLanguageTag = '';

  /** 译员麦克风状态；1-开启，2-关闭 */
  mikeStatus = undefined;

  /** 译员输出频道的传译语言标签，如果是方言则直接是方言名称。如果输出到主频道，则此字段为空字符串。 */
  outputChannelLanguage = '';

  /** 译员互译目标语言名称 */
  toLanguageName = '';

  /** 译员互译目标语言名称简写形式，用于标签展示，如：中、英、zh、en */
  toLanguageNameShort = '';

  /** 译员互译目标语言 tag */
  toLanguageTag = '';

  /** 译员用户 uid */
  uid = '';

  /** 译员参会设备的云信账号uid，如译员未入会此字段为 null */
  yxMeetingUid = undefined;
}

class ConferenceWebEntryConfigurationInformation {
  /** 是否允许web端入会 */
  webEnabled = false;

  /** web端入会链接 */
  webMeetingLink = '';
}

class ControlInformation {
  /** 会中邀请权限：1-所有人可邀请，2-仅主持人可邀请 */
  invitePrivilege = undefined;

  /** 麦克风控制模式是否开启 */
  mickControlOn = false;

  /** 开启麦克风的人数上限 */
  mikeOnLimit = undefined;

  /** 新加入参会人是否静音 */
  muteEnter = false;

  /** 新加入参会人是否静音 按钮是否禁止修改 */
  muteEnterDisabled = false;
}

class ExternalTerminalEntryState {
  /** 内线话机呼叫的号码；或外线话机呼叫中继号码后，继续输入的会议号码 */
  sipChannelId = '';

  /** 内线话机呼叫的号码的展示字段 */
  sipChannelIdDisplay = '';

  /** 外线话机呼叫的中继号码 */
  sipRelayNumber = '';

  /** 外部终端入会是否开启 */
  terminalEntranceEnabled = false;
}

class Feedback {
  /** Feedback */
  doc = '';

  /** id */
  id = undefined;

  /** Feedback语言，参考系统Locale */
  language = '';

  /** Feedback类型，参考枚举 FeedbackDocType */
  type = undefined;
}

class File {
  /** absolute */
  absolute = false;

  /** absoluteFile */
  absoluteFile = {};

  /** absolutePath */
  absolutePath = '';

  /** canonicalFile */
  canonicalFile = {};

  /** canonicalPath */
  canonicalPath = '';

  /** directory */
  directory = false;

  /** executable */
  executable = false;

  /** file */
  file = false;

  /** freeSpace */
  freeSpace = undefined;

  /** hidden */
  hidden = false;

  /** lastModified */
  lastModified = undefined;

  /** name */
  name = '';

  /** parent */
  parent = '';

  /** parentFile */
  parentFile = {};

  /** path */
  path = '';

  /** readable */
  readable = false;

  /** totalSpace */
  totalSpace = undefined;

  /** usableSpace */
  usableSpace = undefined;

  /** writable */
  writable = false;
}

class FocusOnModeInformation {
  /** 专注模式状态：1-开启、2-关闭 */
  focusModeStatus = undefined;

  /** 专注模式开启时，关注的参会人设备ID */
  focusOnMemberDeviceId = '';

  /** 专注模式关注的参会人uid */
  focusOnMemberUid = '';
}

class G2AudioAndVideoParameter {
  /** imAccid */
  imAccid = '';

  /** imToken */
  imToken = '';

  /** 云信G2音视频应用AppId */
  yxMeetingAppId = undefined;

  /** 云信G2音视频应用AppKey */
  yxMeetingAppKey = '';

  /** yxMeetingToken */
  yxMeetingToken = '';

  /** yxMeetingUid */
  yxMeetingUid = undefined;
}

class InputStream {}

class InteractiveWhiteBanCloudCertificationParameters {
  /** Android 白板页面访问地址 */
  androidWhiteboardUrl = '';

  /** 白板应用的云信 appkey */
  appkey = '';

  /** 生成的签名值 */
  checksum = '';

  /** 秒级时间戳 */
  curTime = '';

  /** iOS 白板页面访问地址 */
  iosWhiteboardUrl = '';

  /** iPad 白板页面访问地址 */
  ipadWhiteboardUrl = '';

  /** 随机的 128 位以内的字符串 */
  nonce = '';

  /** 白板房间ID */
  whiteboardChannelId = '';

  /** PC 白板页面访问地址 */
  whiteboardUrl = '';
}

class InterpretationLanguageChannel {
  /** 传译LanguageSubChannel列表 */
  channels = [];
}

class InterpretationVoiceChannelSubscriptionParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** LanguageChannelSubscriptionInformation */
  subscriptions = [];

  /** 是否订阅伙伴频道，1-是，0-否； */
  withPartnerChannels = undefined;
}

class JSONResponseObjectPackaging {
  /** 返回的数据对象 */
  data = new Page();

  /** 提示消息 */
  message = '';

  /** 状态 1成功 */
  status = undefined;
}

class LanguageChannelSubscriptionInformation {
  /** languageTag */
  languageTag = '';
}

class LanguageOption {
  /** 语言代码，如：zh-CHS。 */
  language = '';

  /** 语言名称，如：中文。 */
  name = '';
}

class LanguageSubChannel {
  /** 客户端渲染语言图标时使用的文本 */
  iconWord = '';

  /** InterpretationLanguageChannel展示名，已根据 Locale 国际化。如果是方言频道，则 tag 值为方言名称。 */
  languageName = '';

  /** InterpretationLanguageChannel的语言 tag。如果是方言频道，则 tag 值为方言名称。 */
  languageTag = '';

  /** 云信子房间名 */
  yxSubchannelName = '';
}

class MeetingApplication {
  /** 应用描述 */
  appDesc = '';

  /** 应用ID */
  appId = '';

  /** 应用名称 */
  appName = '';
}

class MeetingChatRoomInformation {
  /** 连接云信聊天室使用的appKey */
  appKey = '';

  /** 聊天室连接地址 */
  chatRoomAddresses = [];

  /** 聊天室是否开启 */
  chatRoomEnabled = false;

  /** 聊天室ID */
  chatRoomId = undefined;

  /** 用户在云信IM系统中的ID */
  yxImAccid = '';

  /** 用户在云信IM系统中的token */
  yxImToken = '';
}

class MemberDynamicSortSettingDto {
  /** 计算发言次数的参考时长，秒。默认 30 分钟，1800 秒 */
  speakingReferenceDuration = undefined;
}

class Page {
  /** current */
  current = undefined;

  /** data */
  data = [];

  /** hasNext */
  hasNext = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class ParticipantsSubscribeToTheSubChannel {
  /** 音频 ASL 选路黑名单，云信账户 uid 集合 */
  audioAslBlacklist = [];

  /** 客户端渲染语言图标时使用的文本 */
  iconWord = '';

  /** InterpretationLanguageChannel展示名，已根据 Locale 国际化。如果是方言频道，则 tag 值为方言名称。 */
  languageName = '';

  /** InterpretationLanguageChannel的语言 tag。如果是方言频道，则 tag 值为方言名称。 */
  languageTag = '';

  /** 云信子房间名 */
  yxSubchannelName = '';
}

class ParticipatingEquipmentModifyYourOwnParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 麦克风状态，参考 PeripheralStatus 枚举 */
  mikeStatus = undefined;

  /** 打开麦克风的方式：1-手动打开且保持开启；2-按住空格键临时开启。默认取值 1 。 */
  mode = undefined;
}

class ParticipatingEquipmentPeripherals {
  /** 外设状态，参考枚举 PeripheralStatus */
  peripheralStatus = undefined;

  /** 外设类型，参考枚举 PeripheralType */
  peripheralType = undefined;
}

class ParticipatingEquipmentThatIsRaisingHand {
  /** 参会设备 ID */
  deviceId = '';

  /** 举手时的时间戳，毫秒 */
  timestamp = undefined;

  /** 参会人 uid */
  uid = '';

  /** 优先用 uid+deviceId 匹配参会设备，不建议使用此字段。参会设备的云信账号 uid。 */
  yxMeetingUid = undefined;
}

class ParticipatorInformationV3 {
  /** 参会人check本场会议时，传递的popo客户端版本号 */
  appVersion = '';

  /** 未入会列表中的参会人，被呼叫时的类型：0-POPO用户，1-会议室，2-话机，3-手机 */
  calleeType = undefined;

  /** 成员所属部门，web端游客无此字段 */
  department = '';

  /** 参会人check本场会议时，使用的客户端设备ID */
  deviceId = '';

  /** 参会人check本场会议时，使用的客户端设备名称 */
  deviceName = '';

  /** 参会人check本场会议时，使用的客户端类型，参考{@link DeviceType} */
  deviceType = undefined;

  /** 成员进入房间时间戳 */
  enterTime = undefined;

  /** TheInformationThatTheParticipantTime。仅未入会参会人返回此字段。注意：calleeType 值为 -1 时，此字段为 null，请谨慎处理！ */
  lastCall = new TheInformationThatTheParticipantTime();

  /** 成员头像地址 */
  memberAvatarUrl = '';

  /** 成员显示名称 */
  memberName = '';

  /** 成员手机号，web端游客无此字段 */
  phoneNumber = '';

  /** 用户角色，参考 MemberRole */
  role = undefined;

  /** 参会人状态，参考 MemberStatus */
  status = undefined;

  /** popo账号是邮箱，游客用户是游客ID */
  uid = '';

  /** 云信IM用户id */
  yxImAccid = '';

  /** 云信音视频用户uid */
  yxUid = undefined;

  /** yxUid的字符串格式，web端防止精度丢失用 */
  yxUidStr = '';
}

class PasswordConfigurationInTheMeeting {
  /** 会议密码 */
  password = '';

  /** 是否启用密码 */
  passwordEnabled = false;

  /** 免密登录范围：1 - 日程参与人免密；2 - POPO 登录用户免密 */
  passwordFreeScopes = [];
}

class ReactionAvailableExpression {
  /** 表情的 Webp 动画时长，毫秒 */
  animationWebpDuration = undefined;

  /** 动画 Webp 图地址后缀。与前缀拼接为 FP 图片访问地址，是一个大图，如果需要不同尺寸可以拼接 fop 参数。 */
  animationWebpSuffix = '';

  /** 表情 ID */
  emoticonId = '';

  /** 表情名称，已经过国际化处理 */
  emoticonName = '';

  /** 排序序号 */
  index = undefined;

  /** 静态 Webp 图地址后缀。与前缀拼接为 FP 图片访问地址，是一个大图，如果需要不同尺寸可以拼接 fop 参数。 */
  staticWebpSuffix = '';
}

class ReactionCanUseTheEmojiList {
  /** 表情列表 */
  emoticons = [];

  /** 表情资源地址前缀，如：https://popofp.vipfp.ps.netease.com/file */
  urlPrefix = '';
}

class ReactionSettingDto {
  /** 举手动态图 */
  handUpAnimWebp = '';

  /** 举手动态图动画时长，毫秒 */
  handUpAnimWebpDuration = undefined;

  /** 举手静态图 */
  handUpStaticWebp = '';
}

class ReportExternalStatusParametersOnEquipment {
  /** 云信会议房间ID */
  channelId = undefined;

  /** ParticipatingEquipmentPeripherals，可批量上报多个外设状态 */
  status = [];
}

class Resource {
  /** description */
  description = '';

  /** file */
  file = new File();

  /** filename */
  filename = '';

  /** inputStream */
  inputStream = new InputStream();

  /** open */
  open = false;

  /** readable */
  readable = false;

  /** uri */
  uri = new URI();

  /** url */
  url = new URL();
}

class SIPIsCalledSquareInformation {
  /** 会议室 ID，sipCalleeType=1 时，传递此字段 */
  meetingRoomId = '';

  /** SIP 设备头像地址。sipCalleeType=3 时传递此参数，其他场景下服务端忽略此参数。 */
  sipAvatarUrl = '';

  /** SIP 被叫方类型：1-会议室，2-话机，3-手机 */
  sipCalleeType = undefined;

  /** SIP 设备名称 */
  sipName = '';

  /** 被叫的 SIP 设备号码 */
  sipNumber = '';
}

class SendEmojiParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 表情 ID */
  emoticonId = '';
}

class ShareScreenStatusModificationParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 共享屏幕状态，参考枚举 ScreenShareStatus  */
  shareStatus = undefined;
}

class SpeakerEnterAlgorithmV1Dto {
  /** 过滤窗口时间内有音量回调的比率低于此值的用户，减少干扰。如：80% */
  ignoreCallbackRateLessThan = undefined;

  /** 过滤音量小于此值的用户，减少干扰。如：20 */
  ignoreVolumeLessThan = undefined;

  /** 音量检测滑动窗长度，毫秒，如：2000 */
  volumeDetectWindowMs = undefined;
}

class SpeakerLeaveAlgorithmV1Dto {
  /** 过滤窗口时间内有音量回调的比率低于此值的用户，减少干扰。如：80% */
  ignoreCallbackRateLessThan = undefined;

  /** 音量检测滑动窗长度，毫秒，如：2000 */
  volumeDetectWindowMs = undefined;
}

class SpeakerTestAlgorithmConfiguration {
  /** 专注时，发言人视频流小窗出现算法（v1）参数 */
  speakerEnterAlgorithmV1 = new SpeakerEnterAlgorithmV1Dto();

  /** 专注时，发言人视频流小窗消失算法（v1）参数 */
  speakerLeaveAlgorithmV1 = new SpeakerLeaveAlgorithmV1Dto();
}

class StreamingPaginationDataPackaging {
  /** 分页数据 */
  data = [];

  /** 是否存在更多记录 */
  hasMore = false;
}

class SubtitleStompConnectionAuthenticationInformation {
  /** 字幕 STOMP 服务订阅地址 */
  stompDestination = '';

  /** 字幕 STOMP 服务连接地址，会拼接认证参数 */
  stompEndpoint = '';
}

class SubtitleTurnOnResultDto {
  /** 字幕作业流水号 */
  jobSerialId = undefined;

  /** 字幕 STOMP 服务认证 code */
  stompAuthCode = '';

  /** 字幕 STOMP 服务认证 token */
  stompAuthToken = '';

  /** 字幕 STOMP 服务订阅地址 */
  stompDestination = '';

  /** 字幕 STOMP 服务连接地址 */
  stompEndpoint = '';

  /** 此次开启字幕的订阅ID */
  subscriptionId = '';
}

class SwitchSubtitleLanguageParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 字幕识别语言类型 */
  language = '';

  /** 当前字幕订阅ID */
  subscriptionId = '';

  /** 是否需要翻译，默认false */
  translate = false;

  /** 如需翻译，翻译至的目标语言 */
  translateTargetLanguage = '';
}

class SwitchTranscriptionLanguageParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 转录语言，传值与字幕相同 */
  language = '';

  /** 是否需要翻译，默认false */
  translate = false;

  /** 如需翻译，翻译至的目标语言 */
  translateTargetLanguage = '';
}

class TheConferenceIsContemporaryInterpretationStatus {
  /** 同声传译状态：1-停止，2-开启 */
  interpretationStatus = undefined;

  /** 译员配置 */
  interpreters = [];
}

class TheInformationThatTheParticipantTime {
  /** 上次被呼叫时，主叫方设备 ID； */
  callerDeviceId = '';

  /** 上次被呼叫时，主叫方 uid； */
  callerUid = '';

  /** 上次被呼叫信号状态：
1-呼叫中
2-已取消，主叫方主动取消
3-已取消，超时取消
4-被叫方拒绝接听
7-排队中，等待呼叫
8-呼叫失败 */
  signalStatus = undefined;

  /** 向 SIP 参会人发起呼叫时的参数。注意：calleeType 值为 1\2\3 时，此字段有值，否则赋值为 null，请谨慎处理！ */
  sipCallParam = new SIPIsCalledSquareInformation();
}

class TheLanguageAvailableInSubtitles {
  /** 实时语音识别 可用的语言类型。 */
  asrLanguages = [];

  /** 实时语音翻译 可用的翻译目标语言类型。实时语音翻译的源语言类型无需指定。 */
  astTargetLanguages = [];

  /** 实时语音识别 默认语言类型，根据客户端 Locale 决定。 */
  defaultAsrLanguage = new LanguageOption();

  /** 实时语音翻译 默认翻译目标语言类型，根据客户端 Locale 决定。 */
  defaultAstTargetLanguage = new LanguageOption();
}

class TouristAvatarClassification {
  /** 分类ID */
  categoryId = undefined;

  /** 分类备注 */
  memo = '';

  /** 分类名称 */
  name = '';
}

class Transcription {
  /** id */
  id = undefined;

  /** name */
  name = '';

  /** speakerYxMeetingUid */
  speakerYxMeetingUid = undefined;

  /** subtitleContent */
  subtitleContent = '';

  /** timestamp */
  timestamp = undefined;

  /** uid */
  uid = '';

  /** url */
  url = '';
}

class TranscriptionStatusInformation {
  /** 转录 Web 组件地址 */
  transcriptionComponentUrl = '';

  /** 转录状态 */
  transcriptionStatus = undefined;
}

class TurnOffSubtitleParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 字幕订阅ID */
  subscriptionId = '';
}

class TurnOnSubtitleParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 字幕识别语言类型 */
  language = '';

  /** 是否需要翻译，默认false */
  translate = false;

  /** 如需翻译，翻译至的目标语言 */
  translateTargetLanguage = '';
}

class URI {
  /** absolute */
  absolute = false;

  /** authority */
  authority = '';

  /** fragment */
  fragment = '';

  /** host */
  host = '';

  /** opaque */
  opaque = false;

  /** path */
  path = '';

  /** port */
  port = undefined;

  /** query */
  query = '';

  /** rawAuthority */
  rawAuthority = '';

  /** rawFragment */
  rawFragment = '';

  /** rawPath */
  rawPath = '';

  /** rawQuery */
  rawQuery = '';

  /** rawSchemeSpecificPart */
  rawSchemeSpecificPart = '';

  /** rawUserInfo */
  rawUserInfo = '';

  /** scheme */
  scheme = '';

  /** schemeSpecificPart */
  schemeSpecificPart = '';

  /** userInfo */
  userInfo = '';
}

class URL {
  /** authority */
  authority = '';

  /** content */
  content = undefined;

  /** defaultPort */
  defaultPort = undefined;

  /** deserializedFields */
  deserializedFields = new URLStreamHandler();

  /** file */
  file = '';

  /** host */
  host = '';

  /** path */
  path = '';

  /** port */
  port = undefined;

  /** protocol */
  protocol = '';

  /** query */
  query = '';

  /** ref */
  ref = '';

  /** serializedHashCode */
  serializedHashCode = undefined;

  /** userInfo */
  userInfo = '';
}

class URLStreamHandler {}

class UserOperationParameters {
  /** 云信会议房间ID */
  channelId = undefined;
}

class WatermarkConfiguration {
  /** 字体颜色 */
  color = '';

  /** 水印显示最大宽度 */
  maxWidth = undefined;

  /** 透明度 */
  opacity = undefined;

  /** 逆时针倾斜角度 */
  rotate = undefined;

  /** 字体大小 */
  size = undefined;

  /** 水印文本 */
  text = '';

  /** 水印元素水平方向上的间距 */
  xSpace = undefined;

  /** 水印元素开始绘制的水平位置 */
  xStart = undefined;

  /** 水印元素竖直方向上的间距 */
  ySpace = undefined;

  /** 水印元素开始绘制的竖直位置 */
  yStart = undefined;

  /** 水印元素的层叠优先级 */
  zIndex = undefined;
}

class WebAvatarDto {
  /** 头像ID */
  avatarId = undefined;

  /** 头像名称 */
  avatarName = '';

  /** 头像分类 */
  categoryId = undefined;

  /** 头像封面地址 */
  coverAvatarUrl = '';

  /** 头像封面地址，320*320 */
  coverAvatarUrl320 = '';

  /** 是否为默认头像 */
  isDefault = false;

  /** 闭麦头像地址 */
  micOffAvatarUrl = '';

  /** 闭麦头像地址，100*100 */
  micOffAvatarUrl100 = '';

  /** 闭麦头像地址，120*120 */
  micOffAvatarUrl120 = '';

  /** 闭麦头像地址，36*36 */
  micOffAvatarUrl36 = '';

  /** 闭麦头像地址，68*68 */
  micOffAvatarUrl68 = '';

  /** 开麦头像地址(不说话) */
  micOnAvatarUrl = '';

  /** 开麦头像地址(不说话)，100*100 */
  micOnAvatarUrl100 = '';

  /** 开麦头像地址(不说话)，120*120 */
  micOnAvatarUrl120 = '';

  /** 开麦头像地址(不说话)，36*36 */
  micOnAvatarUrl36 = '';

  /** 开麦头像地址(不说话)，68*68 */
  micOnAvatarUrl68 = '';

  /** 开麦头像地址(说话) */
  micOnSayingAvatarUrl = '';

  /** 开麦头像地址(说话)，120*120 */
  micOnSayingAvatarUrl120 = '';
}

class WebCheckInForm {
  /** firstMemberNotifyOn */
  firstMemberNotifyOn = undefined;

  /** meetingId */
  meetingId = undefined;

  /** password */
  password = '';

  /** scheduleSt */
  scheduleSt = undefined;
}

class WebMeetingInformation {
  /** 会议开始时间戳，毫秒 */
  beginTime = undefined;

  /** 云信会议名房间ID */
  channelId = undefined;

  /** 云信会议房间名 */
  channelName = '';

  /** 聊天室相关信息 */
  chatRoomStatus = new MeetingChatRoomInformation();

  /** CodeEditorStatus */
  codeEditorStatus = new CodeEditorStatus();

  /** 会控相关信息 */
  controlStatus = new ControlInformation();

  /** 到当前时刻，会议持续的时间，毫秒 */
  currentDuration = undefined;

  /** 服务端当前时刻时间戳，毫秒 */
  currentTimestamp = undefined;

  /** 会议房间从开始到结束的时间，毫秒 */
  duration = undefined;

  /** 会议结束时间戳，毫秒 */
  endTime = undefined;

  /** 会议扩展字段ID */
  externId = '';

  /** FocusOnModeInformation */
  focusModeStatus = new FocusOnModeInformation();

  /** 主持人信息，即members属性中 role 为主持人的参会人，是一个冗余数据，用于快捷读取主持人 */
  host = new ParticipatorInformationV3();

  /** 会议ID */
  meetingId = undefined;

  /** 会议名称 */
  meetingName = '';

  /** 参会人信息 */
  members = [];

  /** 会议模式，参考枚举 MeetingMode */
  mode = undefined;

  /** 入会是否需要密码 */
  needPassword = false;

  /** 用户发送通知的 STOMP 服务连接信息 */
  notifyStompAuth =
    new ConferenceNotifyTheAuthenticationInformationConnection();

  /** 会议的拥有者uid，不一定是主持人uid */
  ownerUid = '';

  /** PasswordConfigurationInTheMeeting */
  passwordStatus = new PasswordConfigurationInTheMeeting();

  /** 录制状态 */
  recordingStatus = new ConferenceRecordingStatus();

  /** 会议开始时间，日程会议才有该字段 */
  scheduleStartTime = '';

  /** 会议开始时间戳，毫秒，日程会议才有该字段 */
  scheduleStartTimeTs = undefined;

  /** 屏幕共享相关信息 */
  screenShareStatus = new ConferenceShareScreenStatusInformation();

  /** SIP入口状态 */
  sipStatus = new ExternalTerminalEntryState();

  /** 会议状态，参考枚举 MeetingStatus */
  status = undefined;

  /** 会议支持的认证方式，可选值有：Guest、NEOpenId、Oscar */
  supportedAuthTypes = [];

  /** 获取会议关联的群组ID，仅群组模式会议存在此字段 */
  teamId = '';

  /** 会议类型，参考枚举 MeetingType */
  type = undefined;

  /** ConferenceWebEntryConfigurationInformation */
  webEntranceStatus = new ConferenceWebEntryConfigurationInformation();

  /** 互动白板相关信息 */
  whiteboardStatus = new ConferenceInteractiveWhiteboardStatusInformation();

  /** 云信应用访问认证信息：G2音视频、IM即时通讯 */
  yxAuth = new G2AudioAndVideoParameter();
}

class WebSettingDto {
  /** 参会人动态排序配置 */
  memberDynamicSortSetting = new MemberDynamicSortSettingDto();

  /** Reaction 配置 */
  reactionSetting = new ReactionSettingDto();

  /** 专注模式全局配置 */
  speakerDetectionSetting = new SpeakerTestAlgorithmConfiguration();
}

class WebSideSession {
  /** authType */
  authType = '';

  /** authed */
  authed = false;

  /** 为web端分配的设备ID */
  deviceId = '';

  /** POPO会议号 */
  meetingId = undefined;

  /** meetingLogged */
  meetingLogged = false;

  /** web成员头像ID */
  memberAvatarId = undefined;

  /** web成员头像地址 */
  memberAvatarUrl = '';

  /** web成员名称 */
  memberName = '';

  /** openAuthed */
  openAuthed = false;

  /** 会话ID */
  sessionId = '';

  /** 用户ID */
  uid = '';

  /** WatermarkConfiguration */
  watermark = new WatermarkConfiguration();

  /** 云信用户ID */
  yxUid = undefined;

  /** yxUid的字符串格式，web端防止精度丢失用 */
  yxUidStr = '';
}

class WebSideSubmissionMeetingFeedbackParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** FeedbackID */
  feedbackDocIds = [];

  /** 反馈类型 */
  feedbackType = undefined;

  /** 是否点赞 */
  isGreat = false;

  /** 会议号 */
  meetingId = undefined;

  /** 反馈建议 */
  remark = '';

  /** web端操作用户uid */
  uid = '';
}

class WebUserLoginMeetingInformation {
  /** 认证方式 */
  authType = '';

  /** 云信会议房间ID */
  channelId = undefined;

  /** 入会check的入口 */
  entrance = undefined;

  /** 游客头像ID */
  guestAvatarId = undefined;

  /** 游客姓名 */
  guestName = '';

  /** 会议号 */
  meetingId = undefined;

  /** operator */
  operator = '';

  /** Web 入会输入的密码 */
  password = '';

  /** 会议pwd参数 */
  pwd = '';
}

export const api = {
  AddTouristAvatarClassificationParameters,
  CodeEditorStatus,
  ConferenceInteractiveWhiteboardStatusInformation,
  ConferenceNotifyTheAuthenticationInformationConnection,
  ConferenceReactionConfiguration,
  ConferenceRecordingRelatedStatus,
  ConferenceRecordingStatus,
  ConferenceShareScreenStatusInformation,
  ConferenceTranslatorConfiguration,
  ConferenceWebEntryConfigurationInformation,
  ControlInformation,
  ExternalTerminalEntryState,
  Feedback,
  File,
  FocusOnModeInformation,
  G2AudioAndVideoParameter,
  InputStream,
  InteractiveWhiteBanCloudCertificationParameters,
  InterpretationLanguageChannel,
  InterpretationVoiceChannelSubscriptionParameters,
  JSONResponseObjectPackaging,
  LanguageChannelSubscriptionInformation,
  LanguageOption,
  LanguageSubChannel,
  MeetingApplication,
  MeetingChatRoomInformation,
  MemberDynamicSortSettingDto,
  Page,
  ParticipantsSubscribeToTheSubChannel,
  ParticipatingEquipmentModifyYourOwnParameters,
  ParticipatingEquipmentPeripherals,
  ParticipatingEquipmentThatIsRaisingHand,
  ParticipatorInformationV3,
  PasswordConfigurationInTheMeeting,
  ReactionAvailableExpression,
  ReactionCanUseTheEmojiList,
  ReactionSettingDto,
  ReportExternalStatusParametersOnEquipment,
  Resource,
  SIPIsCalledSquareInformation,
  SendEmojiParameters,
  ShareScreenStatusModificationParameters,
  SpeakerEnterAlgorithmV1Dto,
  SpeakerLeaveAlgorithmV1Dto,
  SpeakerTestAlgorithmConfiguration,
  StreamingPaginationDataPackaging,
  SubtitleStompConnectionAuthenticationInformation,
  SubtitleTurnOnResultDto,
  SwitchSubtitleLanguageParameters,
  SwitchTranscriptionLanguageParameters,
  TheConferenceIsContemporaryInterpretationStatus,
  TheInformationThatTheParticipantTime,
  TheLanguageAvailableInSubtitles,
  TouristAvatarClassification,
  Transcription,
  TranscriptionStatusInformation,
  TurnOffSubtitleParameters,
  TurnOnSubtitleParameters,
  URI,
  URL,
  URLStreamHandler,
  UserOperationParameters,
  WatermarkConfiguration,
  WebAvatarDto,
  WebCheckInForm,
  WebMeetingInformation,
  WebSettingDto,
  WebSideSession,
  WebSideSubmissionMeetingFeedbackParameters,
  WebUserLoginMeetingInformation,
};
